var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"route-homes-market-chart\"><div class=\"page\"><od-market-analysis-chart statistic=\"{{home_market_chart.statistic}}\" postal-code=\"{{home_market_chart.listing.address.postal_code}}\" market=\"{{home_market_chart.listing.address.market.mls_name}}\" market-label=\"{{home_market_chart.listing.address.market.name}}\" format=\"home_market_chart.formatY({ value: value })\" smoothing=\"{{home_market_chart.smoothing}}\"></od-market-analysis-chart></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/market-chart.jade
 ** module id = 3566
 ** module chunks = 3
 **/